module.exports = __webpack_public_path__ + "img/dp_lp_pc_tw_copy.38732bd7.png";